import { render } from "./BodyComponent.vue?vue&type=template&id=54fea532"
import script from "./BodyComponent.vue?vue&type=script&lang=js"
export * from "./BodyComponent.vue?vue&type=script&lang=js"

import "./BodyComponent.vue?vue&type=style&index=0&id=54fea532&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__